import React, { useState, useEffect } from 'react';
import Text from './Text';
import Button from './Button';
import './Modal.scss';

const Modal = (props) => {
  const classes = 'Modal ' + props.className;
  const [isModalOpen, setModalOpen] = useState(props.isOpen);

  useEffect(() => {
    setModalOpen(props.isOpen);
  }, [props.isOpen]);

  const handleClickButtonModalClose = () => {
    setModalOpen(false);
    if (props.onClose) {
      props.onClose(); 
    }
  };

  if (!isModalOpen) {
    return null; // Return null to not render the modal if it's closed
  }

  return (
    <div className={classes} ref={props.forwardedRef}>
      <div className="Modal__content">
        <Text className={'Modal__text'} content={props.text}></Text>
        <Button className="Modal__button" onClick={handleClickButtonModalClose}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default React.forwardRef((props, ref) => (
  <Modal {...props} forwardedRef={ref} />
));

// };

// const forwardRefModal = React.forwardRef(Modal);

// export default forwardRefModal;
